import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M16.5 4.79964V20.0966C16.5 20.8974 15.529 21.3023 14.9625 20.7354L12.6339 18.4049C12.2832 18.054 11.7168 18.054 11.3661 18.4049L9.03746 20.7354C8.47102 21.3023 7.5 20.8974 7.5 20.0966V4.79964C7.5 3.80984 8.30919 3 9.2982 3H14.6928C15.6908 3 16.5 3.80984 16.5 4.79964Z' />
        </SvgIcon>
    );
});
